export default {
    beforeMount(el, binding) {
      if (binding.value) {
        el.innerHTML = binding.value.replace(/\n/g, '<br>');
      }
    },
    updated(el, binding) {
      if (binding.value) {
        el.innerHTML = binding.value.replace(/\n/g, '<br>');
      }
    }
  };